document.addEventListener('DOMContentLoaded', function () {
    const checkboxId1 = 'Branded Customization-0';
    const checkboxId2 = 'Branded Customization-1';
    const quantityInputId = 'quantity-selector__input-template--23821226737857__main';
    const minQty = '50';

    // Create the observer
    const observer = new MutationObserver((mutations, obs) => {
        const checkbox1 = document.getElementById(checkboxId1);
        const checkbox2 = document.getElementById(checkboxId2);
        if (checkbox1 || checkbox2) {
            console.log('Checkbox found:', checkbox1);

            //Add an event listener
            checkbox1.addEventListener('change', (e) => {
                const quantityInput = document.querySelector('[id^='+quantityInputId+']');
                if (checkbox1.getAttribute('data-checked') == 'true') {
                    quantityInput.min = minQty;
                    const currentQuantity = parseInt(quantityInput.value);
                    const currentMin = parseInt(quantityInput.min)
                    if (currentQuantity < currentMin) {
                        quantityInput.value = currentMin;
                    }
                } else {
                    quantityInput.min = '1';
                }
            });

            //Add an event listener
            checkbox2.addEventListener('change', (e) => {
                const quantityInput = document.querySelector('[id^='+quantityInputId+']');
                if (checkbox2.getAttribute('data-checked') == 'true') {
                    quantityInput.min = minQty;
                    const currentQuantity = parseInt(quantityInput.value);
                    const currentMin = parseInt(quantityInput.min)
                    if (currentQuantity < currentMin) {
                        quantityInput.value = currentMin;
                    }
                } else {
                    quantityInput.min = '1';
                }
            });

            // Stop observing once found (optional)
            obs.disconnect();
        }
    });

    // Start observing the document for changes
    observer.observe(document.body, {
    childList: true,
    subtree: true
    });
});